import AgendaActionContent from './AgendaAction.content.tsx';
import AgendaActionProvider from './AgendaAction.provider.tsx';
import './AgendaAction.styles.scss';

export default function AgendaAction() {
  return (
    <AgendaActionProvider>
      <AgendaActionContent />
    </AgendaActionProvider>
  );
}
